import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { Grid, Typography, Button } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';



import ForgotPassword from '../components/ForgotPassword';
import UserRoles from '../components/UserRoles';


import userActions from '../actions/userActions';
import { LoginRequest } from '../types/LoginRequest';
import { UserData } from '../types/UserData';
import { userService } from '../services/userService';


const styles = (theme: Theme) => createStyles({
    loginLeft: {
        backgroundImage: 'linear-gradient(180deg, #DDF0FF 27.43%, #E8FF98 120.61%)',
        height: '100vh',
        overflow: 'hidden',
        paddingTop: '50px',
        textAlign: 'center',
        '& h2':{
            fontWeight: 600,
        }
    },
    demoButton: {
        background: theme.palette.common.white,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        borderRadius: `${theme.spacing.unit * 7}px`,
        marginTop: `${theme.spacing.unit * 7}px`,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.193756)',
    },
    loginLeftImg:{
        transform: 'scale(.9)',
        paddingBottom: 20,
        display: 'block',
        margin: '0 auto',
    },
    // customContainer:{
    //     display: 'grid',
    //     gridTemplateColumns: '45% 55%',
    // }
});

//@ts-ignore
interface ForgotPasswordContainerProps extends WithStyles<typeof styles> {
    classes: any,
    userData: UserData,
    login: Function,
    setSelectedRole: Function,
}

interface ForgotPasswordContainerState {
}

class ForgotPasswordContainer extends Component<ForgotPasswordContainerProps, ForgotPasswordContainerState>{

    constructor(props: ForgotPasswordContainerProps, state: ForgotPasswordContainerState) {
        super(props);

        this.state = {
        }

        this.forgotPassword = this.forgotPassword.bind(this);
    }

    // renderView() {
    //     const { userData, setSelectedRole } = this.props;

    //     if (userData.isAuthenticated && !userData.selectedRole) {
    //         return (<UserRoles roles={(userData.authenticatedUser ? userData.authenticatedUser.roles : [])} setSelectedRole={setSelectedRole} />)
    //     } if (userData.isAuthenticated) {
    //         return (<Redirect to='/mylibrary' />)
    //     } else {
    //         return (<LoginForm loginSuccess={this.loginSuccess} />)
    //     }
    // }\
    forgotPassword(form:any){
    let host = `${window.location.protocol}//${window.location.hostname}`;

        userService.forgotPassword(form.email, host)
        .then(
            (res) => {
                
            },
            (error: any) => {
            }
        );
    }
    render() {

        const { classes } = this.props;

        return (
            <Grid container>
                <Grid item xs={6} className={classes.loginLeft}>
                    <Typography variant="h6" component="h2">Focus on what you do best and leave <br /> everything else to us</Typography>
                    <Typography variant="subtitle1" component="h4">Academic content authoring and management tool</Typography>
                    <Button className={classes.demoButton}>Watch Demo</Button>
                    <img className={classes.loginLeftImg} src="/assets/img/login-background-bg.png" alt="" />
                </Grid>
                <Grid item xs={6}>
                    <ForgotPassword forgotPassword = {this.forgotPassword}/>
                </Grid>
            </Grid>
        );
    }

}


const mapStateToProps = (state: any) => {
    return {
        userData: state.loginData.userData
    };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    login: userActions.login,
    setSelectedRole: userActions.setSelectedRole
}, dispatch)



// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ForgotPasswordContainer));